import { useClearFilters, useToggleFilter } from "@dxp-feed/algolia";
import { Box } from "@dxp-feed/ui";
import { Checkbox } from "@dxp-feed/ui/Checkbox";
import { setFilters } from "@/utils/redux/productsListing";
import {
  useAppDispatch,
  useAppSelector,
  useEffect,
  useState,
} from "@/utils/hooks/reactUseCustomHooks";
import { useRefine } from "@/templates/provider/RefineContext";
import { analyticsFilterClickEvent } from "@/services/algolia/analytics";
import { forwardRef } from "react";
import { setFavouriteMessage } from "@/utils/redux/favouriteProduct";
import { setShoppingMessage } from "@/utils/redux/shoppingList";
import { setFilterData } from "@/utils/redux/fetchOffers";

type AllergensViewProps = {
  attribute: string;
  name: string;
  index: number;
  onVisibilityChange: (isVisible: boolean) => void;
  isParentOpen: boolean;
};
const AllergensView = forwardRef<HTMLDivElement, AllergensViewProps>(
  ({ attribute, name, index, onVisibilityChange, isParentOpen }, ref) => {
    const { value, refine } = useToggleFilter({ attribute });
    const { refine: clearRefine } = useClearFilters({
      includedAttributes: [attribute],
    });
    const dispatch: any = useAppDispatch();
    const { setRefineFunctions } = useRefine();

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const visibility = !!value?.onFacetValue?.count;
      setIsVisible(visibility);
      onVisibilityChange(visibility);
    }, [value?.onFacetValue?.count]);

    const userSession = useAppSelector((state) => state.gigyaslice);
    const userId = userSession.uid ?? undefined;
    const handleFilterChange = (event: any) => {
      setRefineFunctions((prev) => ({ ...prev, allergens: clearRefine }));
      dispatch(setFavouriteMessage());
      dispatch(setShoppingMessage());
      refine({ isRefined: !event.target.checked });
      dispatch(
        setFilters({
          filter: "allergens",
          filterName: name,
          filterValue: attribute,
        })
      );
      dispatch(
        setFilterData({
          filter: "allergens",
          filterName: name,
          filterValue: attribute,
        })
      );
      analyticsFilterClickEvent({
        kind: "products",
        index: name,
        filters: [`${attribute}:${true}`],
        userToken: userId,
      });
    };

    if (!isVisible) {
      return null;
    }

    return (
      <Box
        as="div"
        data-index={index}
        className="flex items-center gap-2"
        ref={ref}
        tabIndex={isParentOpen ? undefined : -1}
        aria-hidden={!isParentOpen}
      >
        <Checkbox
          id={`checkboxAllergens-${index}`}
          className="m-[15px] min-w-[18px] min-h-[18px]"
          checked={value.isRefined}
          tabIndex={isParentOpen ? 0 : -1}
          onChange={handleFilterChange}
        />
        <label
          htmlFor={`checkboxAllergens-${index}`}
          className="text-[14px] peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
        >
          {name}
        </label>
      </Box>
    );
  }
);

export default AllergensView;
